<script setup lang="ts">
import { logosMediaSrc, logoAltText } from '~/io'
import LogoIcon from '@/components/branding/LogoIcon.vue'
import LogoText from '@/components/branding/LogoText.vue'
import Logo from '@/components/branding/Logo.vue'

const router = useRouter()

const props = withDefaults(defineProps<{
  disableFixed?: boolean
  disableMini?: boolean
}>(), {
  disableFixed: false,
  disableMini: false
})

const { $io } = useNuxtApp()
const fixed = computed(() => !props.disableFixed ? $io.headerFixed : false)
const mini = computed(() => !props.disableMini ? $io.headerFixedMini : false)


</script>

<template>
  <Frame class="sec-header-branding relative" :class="[{ 'header-fixed': fixed }, { 'header-fixed-mini': mini }]"
    w="w-full h-full ">

    <div class="sec-logo-container logo-box" />
    <button class="logo logo-box" @click="router.push('/')">
      

      <!-- <Logo class="logo" /> -->

      <div class="logo-container">
        <img src="/logo.png" alt="Logo">
      </div>

      <!-- <Logo :esta="fixed ? 'var(--a-purple)' : 'white'" :surname="fixed ? 'var(--a-green)' : 'var(--a-green)'"/> -->

      <!-- <div v-if="fixed" key="horizontal" class="logo horizontal">
        <LogoIcon class="logo-icon" body="var(--a-purple)" head="var(--a-purple)" heart="var(--a-green)" />
        <LogoText class="logo-text" />
      </div>
      <div v-else key="vertical" class="logo vertical">
        <LogoIcon class="logo-icon" body="white" head="white" heart="var(--a-green)" />
        <LogoText class="logo-text" aupair="var(--a-purple)" extraordinaire="var(--a-purple)" />
      </div> -->
    </button>

    <!-- <div class="sec-slogan">
     <img src="/perfect-fit.png" alt="Slogan">
    </div> -->

  </Frame>
</template>

<style lang="scss" scoped>
.sec-header-branding {


  height: 100%;
  display: flex;
  align-items: center;

  * {
    transition: all 0.75s ease;
  }

  :deep(>.m-wrap) {
    display: flex;
    align-items: center;

    position: relative;
  }

  // This is the zie of both the logo button and the logo container
  .logo-box {
    position: absolute;
    top: 0;
    left: 20px;
    // Block
    width: 180px;
    height: 70px;
    // border-radius: 0 0 gr(1) gr(1);

    background: transparent;
    border-radius: 0.25rem;

    outline: 0;

    @include mq($until: ds) {
      height: 100px;
      width: 130px;
      left: 10px;
    }
  }

  .sec-logo-container {
    // background: var(--e-light-blue);
    transition: all 0.5s ease;
    // @apply shadow-lg

    background: white;

  }


.sec-slogan {
  position: absolute;
  top: 0;
  left: 300px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  transition: all 0.5s ease;
}

  button.logo {

    background: transparent;
    border: 0;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1px red;

    z-index: 1;

      .logo-icon,
      .logo-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 0.5s ease;
      }

      .logo-icon {
        left: 50%;
        transform: translate(-50%, 27px);
        height: 70px;
        width: 88px;
      }

      .logo-text {
        left: 50%;
        transform: translate(-50%, 112px);
        height: 52px;
      }

      .logo {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 0.5s ease;

        height: 130px;
        left: 50%;
        transform: translate(-50%, 6px);

        @include mq($until: ds) {
          transform: translate(-50%, 0px);
          height: 100px;
          width: 120px;
        }
      }
     
      &:hover {
        .logo-icon {
          // transform: translate(-50%, calc(20px + 1px));
        }

        .logo-text {  
          // transform: translate(-50%, calc(90px + 1px));
        }

        &:active {
          .logo-icon {
            // transform: translate(-50%, calc(20px + 0px));
          }

          .logo-text {
            // transform: translate(-50%, calc(90px + 0px));
          }
        }
      }
  }



  &.header-fixed {

    .logo-box {
      
      @include mq($from: ds) {
        width: 180px;
        height: 80px;
        border-radius: 0.25rem;
      }

      @include mq($until: ds) {
        width: 120px;
        height: 60px;
        border-radius: 0.25rem;
      }

    }

    .sec-logo-container {
      

      @include mq($from: ds) {
        background: var(--e-light-blue);
        box-shadow: none;
        height: 140px;
      }
    }

    .sec-slogan {
      opacity: 0;
      z-index: -1;
    }

    button.logo {

      // box-shadow: inset 0 0 0 1px white;

      .logo-icon,
      .logo-text {
        
      }

      .logo-icon {
        left: 50%;
        transform: translate(calc(-50% - 50px), 10px);
        height: 56px;
      }

      .logo-text {
        left: 50%;
        transform: translate(calc(-50% + 33px), 6px);
        height: 68px;
        width: 90px;
      }

      .logo {
        height: 100px;
        transform: translate(calc(-50%), 15px);

        @include mq($until: ds) {
          transform: translate(calc(-50%), -20px);
          height: 90px;
        }
      }

      

    }


  }
}
</style>